
































export default {
  name: "Footer"
};
